import * as getters from './Getters'
import * as actions from './Actions'
import * as mutations from './Mutations'

//Statelerimiz
const state = () => ({
    loading: false,
    signals: [],
    signalStatus: {},
    signalDetail:{},
    postponeSignals: []
})

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/Alarmsis/Signal/index.js